// Süper admin › Mail Raporları › Şirket Erişim Yönetimi sekmesi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'superadmin.mailReportsCompanyAccess';

export const mailReportsCompanyAccessGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Şirket Erişim Yönetimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Tüm şirketlerin Otomatik Mail Raporları modülünü kullanıp kullanamayacağını bu sekmeden tek noktadan açıp kapatırsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    stats: t(`${G}.regions.stats`, 'Aktif / kapalı sayıları'),
    filters: t(`${G}.regions.filters`, 'Şirket ara'),
    toolbar: t(`${G}.regions.toolbar`, 'Yenile'),
    table: t(`${G}.regions.table`, 'Şirket listesi'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Genel durumu görün'),
      text: t(`${G}.s1.text`, 'Başlığın yanındaki yeşil etiket modülü açık olan şirket sayısını, gri etiket kapalı olan şirket sayısını gösterir (kapalı şirket yoksa gri etiket görünmez).'),
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Şirketi bulun'),
      text: t(`${G}.s2.text`, '"Şirket ara..." kutusuna şirket adını ya da şirket kimliğini (ID) yazın; liste anında süzülür. Yenile düğmesi listeyi sunucudan yeniden yükler.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Sütunları okuyun'),
      text: t(`${G}.s3.text`, 'Her satırda şirket adı ve kimliği, SMTP ve Şablon durumu, zamanlama sayısı, son çalışma zamanı ve Erişim anahtarı bulunur.'),
      tips: [
        t(`${G}.s3.tip1`, 'SMTP: "Özel SMTP" şirkete özel gönderim sunucusu tanımlı demektir; "Global Default" genel varsayılan sunucu kullanılır.'),
        t(`${G}.s3.tip2`, 'Şablon: "Özel" şirketin kendi mail şablonu kayıtlı, "Default" standart şablon kullanılıyor demektir.'),
        t(`${G}.s3.tip3`, 'Zamanlama sütunu "aktif / toplam" zamanlama sayısını gösterir; Son Çalışma Türkiye saatiyle yazılır.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Erişimi açın veya kapatın'),
      text: t(`${G}.s4.text`, 'Satırın sonundaki Erişim anahtarıyla şirketin modülünü açıp kapatın. Değişiklik hemen kaydedilir ve sağ altta "erişim açıldı / erişim kapatıldı" bildirimi görünür; kayıt başarısız olursa anahtar eski haline döner.'),
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Erişim kapalıyken ne olur?'),
      text: t(`${G}.s5.text`, 'Erişimi kapatılan şirketin kullanıcıları Otomatik Mail Raporları sayfasında "Modül Devre Dışı" uyarısı görür. Sunucu, yeni zamanlama oluşturma, zamanlama güncelleme ve test mail gönderme isteklerini reddeder (403 hatası).'),
      tips: [
        t(`${G}.s5.tip1`, 'Kayıtlı zamanlamalar silinmez; ama zamanı gelen otomatik gönderimler mail göndermez, Çalışma Loglarına "Atlandı" (skipped) olarak yazılır.'),
        t(`${G}.s5.tip2`, 'Erişimi yeniden açtığınızda zamanlamalar bir sonraki zamanlarında yeniden mail gönderir; kapalıyken atlanan gönderimler sonradan gönderilmez.'),
        t(`${G}.s5.tip3`, 'Süper admin, erişimi kapalı şirket adına da işlem yapabilir.'),
      ],
    },
  ],
});
